import {API_URL} from "../constants/CONST";


export class User {
    id: number
    name: string

    email?: string
    createdAt?: Date
    country?: string

    constructor(obj: any) {
        this.id = obj.id
        this.name = obj.name
        
        this.email = obj?.email
        this.createdAt = obj?.createdAt ? new Date(obj.createdAt) : undefined
        this.country = obj?.country
    }
    
    getPP(): string {
        return `${API_URL}/users/profilePicture/${this.id}`
    }
}
